import React from "react";
import MarketingShell from "@/components/MarketingShell";
import { currentFullDate } from "@/utils/dates";

export default function Terms() {
  return (
    <MarketingShell>
      <div className="mkt-legal">
        <h1>Terms of Service</h1>
        <p className="mkt-legal-date" data-testid="legal-date-terms">
          Last updated: {currentFullDate()} &nbsp;|&nbsp; The Book Cot
        </p>

        <p>
          Please read these Terms of Service carefully before using any tools or
          services provided by Viral Book Suite, operated by The Book Cot ("we", "us",
          "our"). By accessing or using our tools and services, you agree to be bound
          by these terms.
        </p>

        <h2>1. About Us</h2>
        <p>
          Viral Book Suite is operated by The Book Cot, a company registered in
          England and Wales. Our suite of tools is available at viralbooksuite.com
          and its subdomains. For enquiries, please contact us at:{" "}
          <a href="mailto:hello@viralbooksuite.com">hello@viralbooksuite.com</a>
        </p>

        <h2>2. Use of Our Tools</h2>
        <p>
          Our tools — including Viral Book Studio, Viral Cover Studio, Viral Idea
          Evaluator and PubGlot — are provided for lawful publishing and content
          creation purposes only. By using our tools, you agree that you will:
        </p>
        <ul>
          <li>Use the tools only for legitimate publishing and content creation activities</li>
          <li>Not attempt to reverse engineer, copy, or reproduce the underlying systems</li>
          <li>Not share your access credentials with third parties</li>
          <li>Not use the tools to create content that is unlawful, harmful, defamatory, or infringing on third-party intellectual property rights</li>
          <li>Comply with all applicable laws and regulations in your jurisdiction</li>
        </ul>

        <h2>3. Accounts and Access</h2>
        <p>
          Access to our tools requires purchasing a licence or subscription. You are
          responsible for maintaining the confidentiality of your account credentials
          and for all activity that occurs under your account. You must notify us
          immediately of any unauthorised use of your account.
        </p>

        <h2>4. Intellectual Property</h2>
        <p>
          All content generated using our tools is owned by you, the user. However,
          you acknowledge that the underlying tool frameworks, prompts, systems, and
          interfaces remain the intellectual property of The Book Cot. You may not
          reproduce, distribute, or create derivative works from our tools or their
          underlying systems without explicit written permission.
        </p>

        <h2>5. AI-Generated Content</h2>
        <p>Our tools utilise artificial intelligence to assist with content creation. You acknowledge that:</p>
        <ul>
          <li>AI-generated content may not always be accurate, complete, or suitable for your specific purpose</li>
          <li>You are solely responsible for reviewing, editing, and verifying all AI-generated content before publishing or using it commercially</li>
          <li>We make no warranty regarding the commercial success, viral potential, or royalty earnings achievable using our tools</li>
          <li>Past income figures shared in our marketing reflect the experience of the tool creator and are not guarantees of your results</li>
        </ul>

        <h2>6. Payments and Subscriptions</h2>
        <p>
          Payments for our tools are processed by our third-party payment processor.
          All prices are displayed at the point of purchase and are inclusive of any
          applicable taxes. Subscriptions renew automatically unless cancelled before
          the renewal date. You can manage and cancel your subscription through your
          account dashboard.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by applicable law, The Book Cot shall not be
          liable for any indirect, incidental, special, consequential, or punitive
          damages, including loss of profits, data, or business opportunities, arising
          out of or in connection with your use of our tools. Our total liability to
          you shall not exceed the amount paid by you to us in the three months
          preceding the claim.
        </p>

        <h2>8. Disclaimer of Warranties</h2>
        <p>
          Our tools are provided "as is" without warranties of any kind, either
          express or implied, including but not limited to warranties of
          merchantability, fitness for a particular purpose, or non-infringement. We
          do not warrant that our tools will be uninterrupted, error-free, or free of
          viruses or other harmful components.
        </p>

        <h2>9. Earnings Disclaimer</h2>
        <p>
          Any income figures referenced in our marketing materials represent the
          results of the tool creator and are used for illustrative purposes only.
          Individual results will vary and depend on numerous factors including
          effort, experience, market conditions, and other variables outside our
          control. We make no guarantee that you will earn any specific amount of
          passive income by using our tools.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These Terms of Service are governed by the laws of England and Wales. Any
          disputes arising under these terms shall be subject to the exclusive
          jurisdiction of the courts of England and Wales.
        </p>

        <h2>11. Changes to These Terms</h2>
        <p>
          We reserve the right to update these Terms of Service at any time. We will
          notify you of any material changes by posting the updated terms on this page
          with a revised date. Your continued use of our tools after such changes
          constitutes your acceptance of the new terms.
        </p>

        <h2>12. Contact</h2>
        <p>
          If you have any questions about these Terms of Service, please contact us at{" "}
          <a href="mailto:hello@viralbooksuite.com">hello@viralbooksuite.com</a>.
        </p>
      </div>
    </MarketingShell>
  );
}
